import * as Yup from 'yup';

const holidayValidationSchema = Yup.object().shape({
    holidayName: Yup.string().required('Holiday name is required'),
    holidayDate: Yup.string().required('Date is Required'),
});

export default holidayValidationSchema;
